import { useState, useRef, useEffect } from 'react';
import { Error } from '../error';
import { Collapsible } from '../collapsible';
import { UrlsInput, Select, MultiSelect } from '../input';
import { Inner } from './Inner';
import { ProxyInput } from './input/ProxyInput';
import { VisiterInput } from './input/VisiterInput';
import { IncludeInput } from './input/IncludeInput';
import { Required } from './Required';
import { Optional } from './Optional';
import { paramsInputsStyle } from './shared';

export const RunVisit = (props) => {
  const renderChildren = (params, onChange, setParams, errors) => {
    return (
      <div style={paramsInputsStyle}>
        <Required style={paramsInputsStyle} slim={props.hideAdvanced}>
          <UrlsInput
            label="URLs"
            placeholder="https://... (one per line)"
            value={params.urls}
            onChange={(val) => onChange('urls', val)}
          />
        </Required>

        <div style={{ display: 'flex', gap: 10 }}>
          <IncludeInput params={params} onChange={onChange} errors={errors} />
          <ProxyInput params={params} onChange={onChange} errors={errors} />
          <VisiterInput params={params} onChange={onChange} errors={errors} />
        </div>
      </div>
    );
  };

  const include = ['markdown', 'html', 'urls'];

  const examples = [
    {
      name: 'ipinfo.io',
      params: {
        urls: ['https://ipinfo.io/json'],
        include,
      },
    },
    {
      name: 'pokemondb.net',
      params: {
        urls: ['https://pokemondb.net/pokedex/bulbasaur'],
        include,
      },
    },
    {
      name: 'pokemondb.net 10x',
      params: {
        urls: [
          'https://pokemondb.net/pokedex/bulbasaur',
          'https://pokemondb.net/pokedex/ivysaur',
          'https://pokemondb.net/pokedex/venusaur',
          'https://pokemondb.net/pokedex/charmander',
          'https://pokemondb.net/pokedex/charmeleon',
          'https://pokemondb.net/pokedex/charizard',
          'https://pokemondb.net/pokedex/squirtle',
          'https://pokemondb.net/pokedex/wartortle',
          'https://pokemondb.net/pokedex/blastoise',
          'https://pokemondb.net/pokedex/caterpie',
        ],
        include,
      },
    },
  ];

  return (
    <Inner
      endpoint="visit"
      required={['urls']}
      initialParams={props.params}
      examples={examples}
      renderChildren={renderChildren}
      {...props}
    />
  );
};
